import styled, { css } from 'styled-components';
import Select from '@gotamedia/fluffy/Select';
import { themeHelpers } from '@gotamedia/fluffy/theme';
const Wrapper = styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-1l98r0r-0"
})(["width:100%;flex:1;display:flex;padding:16px 0px;flex-direction:column;background-color:#F5F5F5;"]);
const InnerWrapper = styled.div.withConfig({
  displayName: "style__InnerWrapper",
  componentId: "sc-1l98r0r-1"
})(["max-width:1320px;width:90%;margin:auto;display:flex;flex:1;flex-direction:column;", ""], themeHelpers.isSmallDevice(css(["width:95%;"])));
const HeaderWrapper = styled.div.withConfig({
  displayName: "style__HeaderWrapper",
  componentId: "sc-1l98r0r-2"
})(["display:flex;margin-bottom:16px;"]);
const TotalHitsLabel = styled.p.withConfig({
  displayName: "style__TotalHitsLabel",
  componentId: "sc-1l98r0r-3"
})(["color:#55565A;font-size:14px;line-height:18px;margin:auto auto auto 0;"]);
const SelectWrapper = styled.div.withConfig({
  displayName: "style__SelectWrapper",
  componentId: "sc-1l98r0r-4"
})(["display:flex;margin:auto 0 auto auto;"]);
const SortLabel = styled.p.withConfig({
  displayName: "style__SortLabel",
  componentId: "sc-1l98r0r-5"
})(["font-style:normal;font-weight:400;font-size:14px;line-height:18px;margin:auto 8px;"]);
const SortSelect = styled(Select).attrs(() => {
  return {
    forceDirection: true,
    portalWhenMounted: true
  };
}).withConfig({
  displayName: "style__SortSelect",
  componentId: "sc-1l98r0r-6"
})([""]);
const Content = styled.div.withConfig({
  displayName: "style__Content",
  componentId: "sc-1l98r0r-7"
})(["width:100%;display:grid;gap:30px;justify-content:space-between;grid-template-columns:repeat(auto-fill,185px);", ""], themeHelpers.isSmallDevice(css(["gap:15px;grid-template-columns:repeat(auto-fill,163.5px);"])));
const PaginationWrapper = styled.div.withConfig({
  displayName: "style__PaginationWrapper",
  componentId: "sc-1l98r0r-8"
})(["margin:20px auto;"]);
export { Wrapper, InnerWrapper, HeaderWrapper, TotalHitsLabel, SelectWrapper, SortLabel, SortSelect, Content, PaginationWrapper };